import axios from "axios";
import Swal from "sweetalert2";

export const getDefaultFilterSelect = {
  region: null,
  state: null,
  make: null,
  model: null,
  style: null,
  condition: null,
  fico: null,
  income: null,
  fico_level: null,
  income_level: null,
  sale_price_min: null,
  sale_price_max: null,
  apr_median: null,
  yearOldest: "",
  mileCap: "",
  financedCap: "",
  cashDown: "",
  payCap: "",
  tradeAmt: "",
  paidOffAmt: "",
  zipCode: "",
  stateTax: "",
  dmvFee: "",
};

export const userInputs = ["cashDown", "zipCode", "stateTax", "dmvFee"]; //"tradeAmt","paidOffAmt",

export const userInputsNotDisplayInChip = [
  "cashDown",
  "tradeAmt",
  "paidOffAmt",
  "zipCode",
  "stateTax",
  "dmvFee",
];

export const masterData = [
  "fico_level",
  "income_level",
  "sale_price_min",
  "sale_price_max",
  "apr_median",
];

export const mustRequired = ["income", "fico"];

//Check user inputs entered
export function checkUserInputNotEntered(filterSelectedData) {
  let isNotEntered = false;
  filterSelectedData &&
    Object.keys(filterSelectedData)
      .filter((key) => userInputs.includes(key))
      .map((key) => {
        if (filterSelectedData[key].trim().length === 0) {
          isNotEntered = true;
          return;
        }
      });

  return isNotEntered;
}

//Get Report data based on selected filters and store in filterData Store
export function fetchFilterDataFromDb(
  filterSelectedData,
  props,
  filterDataToStore,
  filterOptionsData = null
) {
  //Check any filter selected, not included user inputs
  let isFilterSelected = false;

  filterSelectedData &&
    Object.keys(filterSelectedData)
      .filter((key) => !userInputs.includes(key))
      .map((key) => {
        if (filterSelectedData[key] && filterSelectedData[key].length > 0) {
          isFilterSelected = true;
          return;
        }
      });

  // update Fico and Income other details need for calculation
  if (filterOptionsData) {
    const ficoIncomeData = filterOptionsData.bandRawData.filter(
      (data) =>
        filterSelectedData.fico.includes(data["fico_band"]) &&
        filterSelectedData.income.includes(data["income_band"])
    );

    const [firstObj] = ficoIncomeData;
    if (firstObj) {
      filterSelectedData.fico_level = firstObj.fico_level;
      filterSelectedData.income_level = firstObj.income_level;
      filterSelectedData.sale_price_min = firstObj.sale_price_min;
      filterSelectedData.sale_price_max = firstObj.sale_price_max;
      filterSelectedData.apr_median = firstObj.apr_median;
    }
  }

  props.filterOptionsSelectedAction(filterSelectedData);

  if (isFilterSelected) {
    //Fetch from DB
    fetchFilterData(filterSelectedData, props, filterDataToStore);
    return true;
  } else {
    filterDataToStore.filterData = [];
    filterDataToStore.isLoading = false;
    props.filterDataAction(filterDataToStore);
    return false;
  }
}

const fetchFilterData = async (
  filterSelectedData,
  props,
  filterDataToStore
) => {
  //set Loading = true and save to store ;
  filterDataToStore.isLoading = true;
  props.filterDataAction(filterDataToStore);

  const hostUrl = process.env.REACT_APP_HOST ? process.env.REACT_APP_HOST : "";
  const payload = {
    client: true,
    filterSelectedData: filterSelectedData,
  };

  await axios
    .post(`${hostUrl}/api/getFilterData`, payload)
    .then((result) => {
      if (result.status !== 200) throw Error(result.statusText);

      filterDataToStore.filterData = result.data.data;
      filterDataToStore.isLoading = false;
      props.filterDataAction(filterDataToStore);
      console.log("Data from DB", filterDataToStore.filterData);

      //success Message
      if (result && result.data.data.length === 0) {
        Swal.fire({
          position: "center",
          icon: "info",
          title: "No Data Found",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        const historyPayload = { ...filterSelectedData };
        historyPayload["email"] = props.user
          ? props.user.email
            ? props.user.email
            : ""
          : "";
        historyPayload["user_name"] = props.user
          ? props.user.name
            ? props.user.name
            : ""
          : "";
        historyPayload["query"] = result.data.query
          ? result.data.query.replaceAll("\n", "")
          : "";

        const payload = { payload: historyPayload, client: true };
        console.log("historyPayload", historyPayload);
        axios
          .post(`${hostUrl}/api/insertFilterQuery`, payload)
          .then((result) => {
            console.log("Result after inserting to history", result.data);
          })
          .catch((err) => {
            console.log("Failed to insert to history table", err.message);
          });
      }
    })
    .catch((err) => {
      filterDataToStore.filterData = [];
      filterDataToStore.isLoading = false;
      props.filterDataAction(filterDataToStore);
      console.log("Error", err.message);
    });
};
